import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  myLocationButtonVariant: 'tertiary'
} satisfies RecursivePartial<DialogConfig['pickupInStore']>
